<template>
  <div class="header">
    <div class="content">
      <div class="left" @click="$router.push('/')">
        <img src="../assets/hikoonhaederlogo.png" alt="" />
        <p class="lefttitle">版权管理系统 | 渠道版</p>
      </div>
      <ul class="right">
        <li v-if="routerName"  @click="$router.push('/download')">
          <el-badge :value="$store.state.message" class="item">
            <img src="../assets/downloadlogo.png" alt="" />
          </el-badge>
        </li>
        <li class="name" @mousemove="userto()" @mouseleave="userout()">{{userName}}</li>
        <li class="user"
         @mousemove="userto()"
        @mouseleave="userout()">
        <img src="../assets/down.png" alt="" />
           <ul ref="content">
            <li @click="loginout()" >退出登录</li>
            <li @click="changeCipher()">修改密码</li>
         </ul>
        </li>
      </ul>
    </div>
    <ChangePassword ref="frame"></ChangePassword>
  </div>
</template>

<script>
import ChangePassword from './ChangePassword.vue'
export default {
    components:{
        ChangePassword
    },
  data() {
    return {
      routerName: false,
      flag: false,
      websock:null,
      tipsPassword:false,
    };
  },
  mounted() {
      this.webskt()
  },
  methods: {
    webskt(){
        // this.websock = new WebSocket("ws://localhost:8080");
        //  console.log(this.websock.readyState)
        // this.websock.onopen=function(){
        //      console.log(123)
        // }
    },
    userto() {
      this.$refs.content.style.opacity = 1;
      this.$refs.content.style.height = '87px';
    },
    userout() {
      this.$refs.content.style.height = '0px';
      this.$refs.content.style.opacity = 0;
    },
    // 退出登录
    loginout() {
        this.$store.commit('loginOut')
      this.$router.replace('/login');
      this.$refs.content.style.height = '0px';
      this.$refs.content.style.opacity = 0;
    },
//    、修改密码
   changeCipher(){
     this.$refs.content.style.height = '0px';
     this.$refs.content.style.opacity = 0;
     this.$refs.frame.dialogVisible=true;
   } 
  },
  updated() {

  },
  computed:{
      userName() {
          if( this.$store.state.user){
               return this.$store.state.user.name;
          }else{
              return ''
          }
         
      }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        if (to.name === 'Download') {
          this.routerName = false;
        } else {
          this.routerName = true;
        }
      },
    },
  },
};
</script>

<style lang='scss' scoped>
.header {
  width: 100%;
  height: 50px;
  background: #1e1b29;
  box-sizing: border-box;
  padding: 0px 57px 0px 50px;
  .content {
    margin: 0px auto;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      cursor: pointer;
      > img {
        width: 39px;
        height: 32px;
        margin-right: 15px;
      }
      > .lefttitle {
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: LEFT;
        color: #ffffff;
      }
    }
    .right {
      color: #ffffff;
      display: flex;
      align-items: center;
      li {
        list-style: none;
      }
      li:nth-child(1) {
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
        }
      }
      .name {
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: RIGHT;
        color: #ffffff;
        margin-left: 30px;
        margin-right: 12px;
         cursor: pointer;
      }
      .user {
        cursor: pointer;
        position:relative;
        >ul{
        opacity: 0;
        position: absolute;
        width: 119px;
        // height: 44px;
        transition: all 0.5s linear;
        overflow: hidden;
        height: 0px;
        background: #ffffff;
        border: 1px solid #f2f2f2;
        border-radius: 2px;
        box-shadow: 0px 4px 4px 0px undefined;
        right:0px;
        top: 25px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: #666666;
        text-shadow: 0px 4px 4px 0px undefined;
        text-align: center;
        line-height:43.5px;
      >li{
          height:43.5px;
      }
        }
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  .item /deep/.el-badge__content {
    width: 14px;
    height: 15px;
    font-size: 11px;
    line-height: 14px;
    font-family: PingFang SC, PingFang SC-Semibold;
    font-weight: 600;
    text-align: CENTER;
    color: #ffffff;
    background: rgba(255, 0, 77, 1);
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue